import { render, staticRenderFns } from "./loadHistoryDetail.vue?vue&type=template&id=34614679&scoped=true"
import script from "./loadHistoryDetail.vue?vue&type=script&lang=js"
export * from "./loadHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./loadHistoryDetail.vue?vue&type=style&index=0&id=34614679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34614679",
  null
  
)

export default component.exports